<template>
  <div >
    <div class="swiper-container">
        <!-- Additional required wrapper -->
        <div class="swiper-wrapper">
          <!-- Slides -->
          <div class="swiper-slide" v-for="(item, index) in List" :key="index">
            <div class="case_div">
              <img :src="item.showImg" />
              <div class="cover_div">
                <div class="p_div">
                  <p class="title">{{ item.title }}</p>
                  <p class="litter_line"></p>
                  <p class="content">{{ item.simple }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- If we need navigation buttons -->
        <img
          class="swiper-button-prev"
          src="../../static/img/百康源网站-首页2.png"
        />
        <img
          class="swiper-button-next"
          src="../../static/img/首页切片-17.png"
        />
      </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      List: [
        {
          showImg: "",
        },
      ],
    };
  },
  created() {},
  computed: {},
  mounted() {
    this.Init();
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop);
    clearInterval(this.timer);
    this.timer = null;
  },
  watch: {
    //监听路由变化
    $route(to, from) {
      this.Init();
    },
    //监听轮播数据变化后再创建实例
    List() {
      this.$nextTick(() => {
        new Swiper(".swiper-container", {
          slidesPerView: 2,
          spaceBetween: 30,
          centeredSlides: true,
          loop: true, // 循环模式选项
          autoplay: true,
          // Optional parameters
          // observer: true,
          // observeParents: true,
          // observeSlideChildren: true,
          // Navigation arrows
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        });
      });
    },
  },
  methods: {
    Init() {
      this.getInfo();
    },
    getInfo(menutype) {
      let that = this;
      let plate = "";
      let business = "";
      let title = "";

      this.$axios
        .get("api/case/list")
        .then(function (response) {
          console.log(response);
          var status = response.data.code;
          if (status === 0) {
            that.List = response.data.page.list;
            console.log(that.List);
            sessionStorage.setItem("input", "null");
          }
          console.log("that.List");
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>
<style lang="stylus" scoped>
.home_banner {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  --swiper-pagination-color: var(--textBlue);

  div {
    width: 100%;
    height: 50vw;
    margin-left: auto;
    margin-right: auto;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

.swiper-pagination {
  top: 0;
  z-index: 999;
  margin-top: 56vw;
}

@media screen and (min-width: 2000px) {
  .swiper-pagination {
    margin-top: 50vw;
  }
}

@media screen and (max-width: 800px) {
  .home_banner {
    div {
      height: auto;
    }
  }

  .swiper-pagination {
    margin-top: 29rem;
  }
}

</style>